const data = [
    {
        img : "foodhub/bibimbap.png",
        alt : "image1",
        foodname: "Stir fry pasta",
        p1: " The in-house pasta and chicken by chef jane",
        price: "N1500",
        cart: "Add to cart"
    },
    {
        img : "foodhub/bon-vivant-qom5MPOER-I-unsplash 2.png",
        alt : "image2",
        foodname: "Stir fry pasta",
        p1: "The in-house pasta and chicken by chef jane",
        price: "N2500",
        cart: "Add to cart"
    },    
    
    {
        img : "foodhub/bon-vivant-qom5MPOER-I-unsplash 4.png",
        alt : "image3",
        foodname: "Stir fry pasta",
        p1: "The in-house pasta and chicken by chef jane",
        price: "N1000",
        cart: "Add to cart"
    },

    {
        img : "foodhub/bon-vivant-qom5MPOER-I-unsplash 2.png",
        alt : "image4",
        foodname: "Stir fry pasta",
        p1: "The in-house pasta and chicken by chef jane",
        price: "N5000",
        cart: "Add to cart"
    },
    {
        img : "foodhub/bon-vivant-qom5MPOER-I-unsplash 2.png",
        alt : "image5",
        foodname: "Stir fry pasta",
        p1: " The in-house pasta and chicken by chef jane",
        price: "N1750",
        cart: "Add to cart"
    },{
        img : "foodhub/bon-vivant-qom5MPOER-I-unsplash 2.png",
        alt : "image6",
        foodname: "Stir fry pasta",
        p1: " The in-house pasta and chicken by chef jane",
        price: "N3000",
        cart: "Add to cart"
    },

    {
        img : "foodhub/bon-vivant-qom5MPOER-I-unsplash 2.png",
        alt : "image7",
        foodname: "Stir fry pasta",
        p1: " The in-house pasta and chicken by chef jane",
        price: "N5500",
        cart: "Add to cart"
    },
    {
        img : "foodhub/bon-vivant-qom5MPOER-I-unsplash 2.png",
        alt : "image8",
        foodname: "Stir fry pasta",
        p1: " The in-house pasta and chicken by chef jane",
        price: "N2000",
        cart: "Add to cart"
    },{
        img : "foodhub/bon-vivant-qom5MPOER-I-unsplash 2.png",
        alt : "image9",
        foodname: "Stir fry pasta",
        p1: " The in-house pasta and chicken by chef jane",
        price: "N4000",
        cart: "Add to cart"
    }
]

export default data